var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailVerifiedFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    id: "verify-email",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "evenodd",
    d: "M1 7C1 5.34315 2.34315 4 4 4H20C21.6569 4 23 5.34315 23 7V17C23 18.6569 21.6569 20 20 20H4C2.34315 20 1 18.6569 1 17V7Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#850026",
    fillRule: "evenodd",
    d: "M5.61786 6.71372C5.18359 6.37251 4.55494 6.44795 4.21372 6.88222C3.87251 7.31649 3.94795 7.94515 4.38222 8.28636L10.1466 12.8155C11.2344 13.6702 12.7657 13.6702 13.8535 12.8155L19.6179 8.28636C20.0521 7.94515 20.1276 7.31649 19.7864 6.88222C19.4451 6.44795 18.8165 6.37251 18.3822 6.71372L12.6179 11.2429C12.2553 11.5278 11.7448 11.5278 11.3822 11.2429L5.61786 6.71372ZM16.2929 21.7071C15.9024 21.3166 15.9024 20.6834 16.2929 20.2929L18.0858 18.5L16.2929 16.7071C15.9024 16.3166 15.9024 15.6834 16.2929 15.2929C16.6834 14.9024 17.3166 14.9024 17.7071 15.2929L19.5 17.0858L21.2929 15.2929C21.6834 14.9024 22.3166 14.9024 22.7071 15.2929C23.0976 15.6834 23.0976 16.3166 22.7071 16.7071L20.9142 18.5L22.7071 20.2929C23.0976 20.6834 23.0976 21.3166 22.7071 21.7071C22.3166 22.0976 21.6834 22.0976 21.2929 21.7071L19.5 19.9142L17.7071 21.7071C17.3166 22.0976 16.6834 22.0976 16.2929 21.7071Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0,
    x2: 16.605,
    y1: 3.273,
    y2: 26.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.083,
    stopColor: "#FF6A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F72257"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailVerifiedFailed);
export default __webpack_public_path__ + "static/media/email-verified-failed.2ee69bd684f19b242a8c2be3b5790ee2.svg";
export { ForwardRef as ReactComponent };